<template>
  <div class="row justify-content-center mt-5">
    <card shadow>
      <div slot="header" class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-8">
            <h3 class="mb-0">Solicitação de Exclusão de Conta</h3>
          </div>
        </div>
      </div>
      <template>
        <form role="form" class="vld-parent" ref="support_form">
          <div class="row ml-2">
            <div class="col-lg-12">
              <p>
                Você está solicitando a exclusão da sua conta, para isso
                preencha o formulário abaixo e dentro de dois dias úteis
                entraremos em contato via email para validar a sua identidade.
              </p>

              <base-input
                label="Email da conta"
                placeholder="Ex: fulano@starsaceleradora.com"
                v-model="model.email"
              />
              <base-input
                label="Nome do dono da conta"
                placeholder="Ex: João Pereira da Silva"
                v-model="model.ownerName"
              />
              <base-input
                label="Número de celular para contato"
                placeholder="Ex: 55 99999-9999"
                v-model="model.cellphone"
              >
                <the-mask
                  mask="## #####-####"
                  v-model="model.cellphone"
                  class="form-control"
                  type="tel"
                  placeholder="Ex: 55 99999-9999"
                />
              </base-input>
              <label class="form-control-label"> Motivo da solicitação: </label>
              <div>
                <base-input addon-left-icon="ni ni-support-16">
                  <select class="form-control" v-model="model.reason">
                    <option selected disabled value="">
                      Selecione um motivo
                    </option>
                    <option
                      v-for="category in reasonSelect"
                      :key="category.key"
                      :value="category.key"
                    >
                      {{ category.value }}
                    </option>
                  </select>
                </base-input>
              </div>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label"> Detalhes adicionais: </label>
              <textarea
                placeholder="Digite os detalhes"
                class="input-group-text form-control col-12 text-left text-muted"
                style="min-height: 100px"
                v-model="model.aditionalDetails"
              >
              </textarea>
            </div>
          </div>
          <hr class="mt-2 mb-4" />
          <div class="row ml-2">
            <div class="col-12">
              <base-alert
                type="danger"
                class="text-center mt-4 mb-0"
                v-if="error"
                ><i class="fas fa-exclamation-circle mr-1"></i>
                {{ error }}</base-alert
              >
              <base-alert
                v-if="success"
                type="success"
                class="text-center mt-4 mb-0"
                ><i class="fas fa-thumbs-up mr-1"></i> {{ success }}</base-alert
              >
            </div>
            <div class="col-12 mt-4 text-right">
              <base-button
                type="primary"
                :disabled="responded"
                :custom="true"
                @click="handleSubmit"
                >Enviar Solicitação</base-button
              >
            </div>
          </div>
        </form>
      </template>
    </card>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "politica-de-privacidade",
  data() {
    return {
      model: {
        email: "",
        ownerName: "",
        cellphone: "",
        reason: "",
        aditionalDetails: "",
      },
      reasonSelect: [
        { value: "Não estou satisfeito com o serviço", key: "nao_satisfeito" },
        { value: "Não consigo acessar minha conta", key: "nao_acesso" },
        {
          value: "Não faço parte mais parte da rede",
          key: "nao_pertencimento",
        },
        { value: "Outro motivo", key: "outro" },
      ],
      success: "",
      error: "",
    };
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      const loader = this.$loading.show({
        width: 140,
        height: 140,
      });
      try {
        this.sucess = this.error = "";
        await api.post("/request-delete-account", this.model);
        this.success = "Sua requisição foi enviada com sucesso.";
      } catch (error) {
        this.error = "Ocorreu um erro ao mandar a requisição.";
      }
      loader.hide();
    },
  },
  computed: {
    responded() {
      for (let key in this.model) {
        if (key != "aditionalDetails" && !this.model[key].length > 0)
          return true;
      }
      return this.success.length > 0;
    },
  },
};
</script>
<style scoped>
.list-bold {
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
}
ol > li {
  font-weight: bold;
}
ul + p,
li + p {
  margin-top: 1rem;
}
</style>
